import React from 'react'
import ReactGA from 'react-ga'
import { Link, useParams } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { getStringFromJSX } from '../../helpers/getStringFromJSX'
import Carousel from '../UI/Carousel/Carousel'
import { Footnote } from '../UI/Footnote/Footnote'
import styles from './NewThematicContent.module.scss'
import {
  NewThematicContentProps,
  NewThematicContentTypes,
} from './NewThematicContent.types'

export const NewThematicContent = ({
  data,
  darkTheme,
  footnote,
}: NewThematicContentTypes) => {
  const { id } = useParams()

  const handleLinkClick = (e: any) => {
    const name = e.target.textContent

    ReactGA.ga('send', 'event', 'client link', 'collection text link', name)
    ReactGA.ga('rbcspec.send', 'event', 'client link', 'click')

    ym('reachGoal', 'client link', {
      'client link': {
        'collection text link': {
          [`Подборка ${id}`]: name,
        },
      },
    })
  }

  const BtnLink = ({
    item,
    type,
  }: {
    item: NewThematicContentProps
    type: string
  }) => {
    if (!item?.buttonName) return null

    return (
      <div className={[styles.btn, `for-${type}`].join(' ')}>
        <Link
          className={`btn btn-border ${darkTheme ? 'btn--dark' : ''}`}
          to={item?.url ? item?.url : '/'}
          target={item?.urlInner ? '_self' : '_blank'}
          onClick={handleLinkClick}
        >
          {item?.buttonName ?? 'Смотреть коммерческие помещения'}
        </Link>
      </div>
    )
  }

  return (
    <section className='section'>
      <div
        className={`${styles.wrapper}
          ${darkTheme ? styles['thematicWrapper--dark'] : ''}
      `}
      >
        {data.map((item, index) => (
          <div className={styles.block__wrapper} key={index}>
            <div className={styles.block}>
              <BtnLink item={item} type='devices' />
              {/* слайдер в подборке */}
              {item.slider && (
                <div className={styles['carousel-wrapper']}>
                  <Carousel
                    slides={item.slider.map(img => (
                      <img src={img} alt={getStringFromJSX(item?.title)} />
                    ))}
                  />
                </div>
              )}
              {/* картинка в подборке */}
              {item.image && (
                <img src={item.image} alt={getStringFromJSX(item?.title)} />
              )}
              <div className={styles.content}>
                <h3>{item?.title}</h3>
                <p>{item?.text}</p>

                {!item.buttonCenter && <BtnLink item={item} type='desktop' />}
              </div>
            </div>
            {item.buttonCenter && (
              <div className={styles.center}>
                <BtnLink item={item} type='desktop' />
              </div>
            )}
          </div>
        ))}
      </div>
      {footnote && <Footnote content={footnote} />}
    </section>
  )
}
